    import { LuSearch } from "@/Components/Icons/Icons.jsx";
    export default {
        row1 :[
    {
        column: "column1",
        rows: {
        row1: [
            {
            name: "exportConsituentName",
            label: "Name",
            component: "text-field",
            },
            {
            name: "exportConsituentCode",
            label: "Code",
            component: "text-field",
            },
        ],
        row2: [
            {
            name: "exportConsituentPercentage",
            label: "Percentage",
            component: "text-field",
            dataType : "int"
            },
            {
            name: "exportConsituentYield",
            label: "Yield %",
            component: "text-field",
            dataType:"int"
            },
        ],
          row3: [
            {
              name: "exportConsituentActive",
              label: "Active",
              component: "text-field",
              width:"50%"
            },
          ],
        },
    },
    ]
    };
